import { DIRECTIONS } from '@btime/constants'
import { useDrop } from 'react-dnd'
import React from 'react'

import { Relative } from '../helpers/Position'
import { useDndState, useIsDraggingType } from './DndHandler'
import Panel from '../structure/Panel'
import SeparatorWrapper from '../helpers/SeparatorWrapper'

const Droppable = ({ onDrop, type, children, placeholderWeight }) => {
  const { disabled } = useDndState()
  const isDragging = useIsDraggingType(type)

  const [{ isOverTop }, dropOnTopWrapper] = useDrop({
    accept: type,
    collect: monitor => ({
      isOverTop: monitor.isOver({ shallow: true })
    }),
    drop(item, monitor) {
      onDrop(item, DIRECTIONS.UP)
    }
  })

  const [{ isOverBottom }, dropOnBottomWrapper] = useDrop({
    accept: type,
    collect: monitor => ({
      isOverBottom: monitor.isOver({ shallow: true })
    }),
    drop(item, monitor) {
      onDrop(item, DIRECTIONS.DOWN)
    }
  })

  if (disabled) return children

  const placeholder = (
    <Panel lineBorder noMargin noRadius noPadding>
      <SeparatorWrapper weight={placeholderWeight || 18} />
    </Panel>
  )

  const commonStyle = {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: isDragging ? 10 : -1
  }

  return (
    <Relative>
      {isOverTop && placeholder}
      <div ref={dropOnTopWrapper} style={{ ...commonStyle, bottom: '50%' }}></div>
      <div ref={dropOnBottomWrapper} style={{ ...commonStyle, top: '50%' }}></div>
      {children}
      {isOverBottom && placeholder}
    </Relative>
  )
}

export default Droppable
